import React from "react";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import { DATA_ORDER_SERVICE_STATUS } from "../data/options";
import { Group } from "@mantine/core";
import moment from "moment";
import { useTranslation } from "react-i18next";
import EntityTabAnchor, {
  ENTITY_TAB_ANCHOR_PLAIN_SX,
} from "../pages/account/payroll2/EntityTabAnchor";
import { getOrderServiceRelatedPages } from "../helpers/orderServiceRelatedPages";

const relatedLink = (entity, page) =>
  page ? (
    <EntityTabAnchor
      entity={entity}
      id={page.id}
      label={page.label}
      fallback="-"
      size="sm"
      weight={600}
      underline={false}
      sx={ENTITY_TAB_ANCHOR_PLAIN_SX}
    />
  ) : (
    "-"
  );

export default function OrderServiceSummary({ form }) {
  const [cellRender] = useCellRender();
  const service = form.values;
  const status = DATA_ORDER_SERVICE_STATUS.find((s) => s.value === service?.status);
  const { t } = useTranslation();
  const related = getOrderServiceRelatedPages(service);
  const fields = [
    {
      title: "Service Code",
      value: <Group>{service?.code}</Group>,
    },
    {
      title: "Service Type",
      value: (
        <Group>
          {service?.serviceType?.name} {service?.serviceType?.cname}
        </Group>
      ),
    },
    {
      title: "Status",
      value: status ? (
        <Group>
          {cellRender.Order.status(service?.status)}
          {t(status?.label)}
        </Group>
      ) : (
        "Unknown"
      ),
    },
    {
      title: "Order",
      value: relatedLink("order", related.order),
    },
    {
      title: "Client",
      value: relatedLink("client", related.client),
    },
    {
      title: "Provider",
      value: relatedLink("provider", related.provider),
    },
    {
      title: "Product",
      value: relatedLink("product", related.product),
    },
    {
      title: "Created At",
      value: (
        <Group>
          {service?.createdAt
            ? moment(service?.createdAt).format("YYYY-MM-DD")
            : ""}
        </Group>
      ),
    },

    {
      title: "Received At",
      value: (
        <Group>
          {service?.receieveDate
            ? moment(service?.receieveDate).format("YYYY-MM-DD")
            : ""}
        </Group>
      ),
    },

    {
      title: "Submitted At",
      value: (
        <Group>
          {service?.submissionDate
            ? moment(service?.submissionDate).format("YYYY-MM-DD")
            : ""}
        </Group>
      ),
    },

    {
      title: "Completed At",
      value: (
        <Group>
          {service?.completeDate
            ? moment(service?.completeDate).format("YYYY-MM-DD")
            : ""}
        </Group>
      ),
    },
    {
      title: "Description",
      value: <Group>{service?.description}</Group>,
    },
  ];

  return <InfoGridList fields={fields} values={service} />;
}
